if (document.querySelector(".template-collection")) {
  if (document.querySelector(".banner__links-mobile")) {
    const openSelect = document.querySelector(".banner__links-mobile-main");
    const openContent = document.querySelector(".banner__links-mobile-content");

    openSelect.addEventListener("click", () => {
      openSelect.classList.toggle("active");
      openContent.classList.toggle("active");
    });
  }

  function addContentOnPage() {
    const productsWrapper = document.querySelector(".collection__products");
    let tot, cur;
    const dataTotalPages = document.querySelector("[data-total-pages]");
    const dataCurrentPage = document.querySelector("[data-current-page]");
    if (dataTotalPages) tot = dataTotalPages.getAttribute("value");
    if (dataCurrentPage) cur = dataCurrentPage.getAttribute("value") - 1;

    if (cur >= tot) {
      productsWrapper.classList.add("hideMore");
    } else {
      productsWrapper.classList.remove("hideMore");
    }

    if (!cur && !tot) productsWrapper.classList.add("hideMore");

    $(".js-load-more").on("click", function () {
      const productColWrapper = document.querySelector(".collection__products");
      var $this = $(this),
        totalPages = parseInt($("[data-total-pages]").val()),
        currentPage = parseInt($("[data-current-page]").val());
      $this.attr("disabled", true);
      $this.find("[load-more-text]").addClass("hide");
      $this.find("[loader]").removeClass("hide");
      var nextUrl = $("[data-next-url]")
        .val()
        .replace(/page=[0-9]+/, "page=" + currentPage);
      $("[data-current-page]").val(currentPage);
      $.ajax({
        url: nextUrl,
        type: "GET",
        dataType: "html",
        success: function (responseHTML) {
          $(".collection__products").append(
            $(responseHTML).find(".collection__products").html()
          );
          history.pushState(
            {
              page: nextUrl,
            },
            nextUrl,
            nextUrl
          );

          const hiddenBlocks = document.querySelectorAll(".hidden-block");
          const buttons = document.querySelectorAll(".load-more_wrap");
          const displayed = document.querySelectorAll(".displayed");
          for (let index = 0; index < hiddenBlocks.length - 1; index++) {
            hiddenBlocks[index].remove();
          }
          for (let index = 0; index < buttons.length - 1; index++) {
            buttons[index].remove();
          }
          for (let index = 0; index < displayed.length - 1; index++) {
            displayed[index].remove();
          }
        },
        complete: function () {
          addContentOnPage();
          if (currentPage >= totalPages) {
            $this.attr("disabled", false);
            $this.find("[load-more-text]").removeClass("hide");
            $this.find("[loader]").addClass("hide");
            const loadMore = document.querySelector(".load-more_wrap");
            loadMore.classList.add("load-more_wrap_hidden");
            document
              .querySelector(".hidden-block")
              .classList.add("hidden-block_hidden");
          }
          if (document.querySelectorAll(".product-item").length % 3 == 0) {
            productColWrapper.classList.remove("two");
          }

          productCard();
          lazyLoadProductImages();
        },
      });
    });
  }

  addContentOnPage();

  window.addEventListener("DOMContentLoaded", function () {
    let totalPages = parseInt($("[data-total-pages]").val());
    let currentPage = parseInt($("[data-current-page]").val());
    if (currentPage > totalPages) {
      const loadMore = document.querySelector(".load-more_wrap");
      if (loadMore) loadMore.classList.add("load-more_wrap_hidden");
    }
  });

  const openTypes = document.querySelector(
    ".filter__buttons .filter__buttons-type"
  );
  const openFilters = document.querySelector(
    ".filter__buttons .filter__buttons-filter"
  );
  const contentTypes = document.querySelector(".filter__type");
  const contentFilters = document.querySelector(".filter__form");

  openTypes.addEventListener("click", () => {
    removeActive(openFilters, contentFilters);
    filters(openTypes, contentTypes);
  });

  openFilters.addEventListener("click", () => {
    removeActive(openTypes, contentTypes);
    filters(openFilters, contentFilters);
  });

  function filters(trigger, content) {
    trigger.classList.toggle("active");
    content.classList.toggle("active");
  }

  function removeActive(trigger, content) {
    trigger.classList.remove("active");
    content.classList.remove("active");
  }
}

function productCard() {
  const productcard = document.querySelectorAll(".product-card__product");
  const activeType = document.querySelector(".filter__list-item .active");

  function colorSwatchs() {
    productcard.forEach((card) => {
      const productImages = card.querySelectorAll(".product-card__image img");
      const productSwatchs = card.querySelectorAll(".product-card__color");
      const productSelect = card.querySelector(".product-card__select");
      const productFormAddToCart = card.querySelector(".product-card__addcart");
      const productPrice = card.querySelector(".product-card__price");

      productSwatchs.forEach((swatch) => {
        if (swatch.classList.contains("active")) {
          activateImage(swatch, productImages);
          activateImageHover(card);
        }
        swatch.addEventListener("click", () => {
 
          let activeSize = card.querySelector(".product-card__size.active");
          const firstSize = card.querySelectorAll(".product-card__size")[0];

          if (activeSize) {
            activeSize = activeSize.dataset.option;
          } else {
            if (typeof firstSize != "undefined") {
              activeSize = firstSize.dataset.option;
            }
          }
        
          removeActive(productSwatchs);
          swatch.classList.add("active");

   
          
          activateImage(swatch, productImages);
          activateImageHover(card);
          Array.from(productSelect).forEach((option) => {
            const optionColor = option.dataset.title.split(" / ")[1];
            const optionSize = option.dataset.title.split(" / ")[0];
            if (
              optionColor === swatch.dataset.option &&
              optionSize === activeSize
            ) {
              if (option.dataset.available == "false") {
                productFormAddToCart.innerHTML = "Sold Out";
                productFormAddToCart.disabled = true;
              } else {
                productFormAddToCart.innerHTML = "Add to Cart";
                productFormAddToCart.disabled = false;
              }
              option.selected = true;

              if (
                typeof option.dataset.comparePrice != "undefined" &&
                option.dataset.comparePrice != ""
              ) {
                checkComparePrice(
                  option.dataset.price,
                  option.dataset.comparePrice,
                  productPrice
                );
              } else {
                checkComparePrice(option.dataset.price, "", productPrice);
              }
            }
          });
        });
      });
    });
  }

function activateImage(swatch, productImages) {
  productImages.forEach((image) => {
    let imgAlt = image.alt;
    if (imgAlt.includes(" &")) {
      imgAlt = imgAlt.split(" &")[0];
    }
    let imageAltColor = imgAlt.split(" /")[0];
    let imageAltType = imgAlt.split(" / ")[1];

    // Check if this image should be activated
    if (activeType) {
      const activeTypeData = activeType.dataset.activeTag;
      if (imageAltColor == swatch.dataset.option && activeTypeData == imageAltType) {
        updateImageSrc(image); // Update src before setting active
        image.classList.add("active");
      }
    } else {
      if (imageAltColor == swatch.dataset.option) {
        updateImageSrc(image); // Update src before setting active
        image.classList.add("active");
      }
    }
  });
}

function updateImageSrc(image) {
  if (image.dataset.imgsrc && image.src !== image.dataset.imgsrc) {
    image.src = image.dataset.imgsrc;
  }
}


  function activateImageHover(card) {
    const activeImages = card.querySelectorAll(
      ".product-card__image img.active"
    );
    const activeImagesFirst = activeImages[0];
    const activeImagesHover = activeImages[1];
    if (activeImagesFirst) {
      activeImagesFirst.classList.add("first_show");
    }
    if (activeImagesHover) {
      activeImagesHover.classList.add("hover_show");
    }
  }

  function changeSize() {
    productcard.forEach((card) => {
      const sizes = card.querySelectorAll(".product-card__size");
      const productForm = card.querySelector(".product-card__form");
      const productSelect = card.querySelector(".product-card__select");
      const productFormAddToCart = card.querySelector(".product-card__addcart");
      const productPrice = card.querySelector(".product-card__price");

      sizes.forEach((size) => {
        size.addEventListener("click", () => {
          let activeColor = card.querySelector(".product-card__color.active");
          if (activeColor) {
            activeColor = activeColor.dataset.option;
          }

          removeActive(sizes);
          size.classList.add("active");
          productForm.classList.add("active");
          Array.from(productSelect).forEach((option) => {
            if (option.dataset.title.includes(" / ")) {
              const optionSize = option.dataset.title.split(" / ")[0];
              const optionColor = option.dataset.title.split(" / ")[1];
              if (
                optionSize === size.dataset.option &&
                activeColor === optionColor
              ) {
                if (option.dataset.available == "false") {
                  productFormAddToCart.innerHTML = "Sold Out";
                  productFormAddToCart.disabled = true;
                } else {
                  productFormAddToCart.innerHTML = "Add to Cart";
                  productFormAddToCart.disabled = false;
                }
                option.selected = true;

                if (
                  typeof option.dataset.comparePrice != "undefined" &&
                  option.dataset.comparePrice != ""
                ) {
                  checkComparePrice(
                    option.dataset.price,
                    option.dataset.comparePrice,
                    productPrice
                  );
                } else {
                  checkComparePrice(option.dataset.price, "", productPrice);
                }
              }
            } else if (!activeColor) {
              const optionTitle = option.dataset.title;
              if (optionTitle === size.dataset.option) {
                option.selected = true;
              }
            }
          });
        });
      });
    });
  }

  function checkComparePrice(price, comparePrice, productPrice) {
    if (comparePrice != "" && price != "") {
      productPrice.innerHTML =
        price + " <span class='compare-price'>" + comparePrice + "</span>";
    } else if (price != "") {
      productPrice.innerHTML = price;
    }
  }

  colorSwatchs();
  changeSize();

  function removeActive(array) {
    array.forEach((item) => {
      item.classList.remove("active");
    });
  }
}

productCard();


function lazyLoadProductImages() {
    const images = document.querySelectorAll('.product-card__image img'); // Replace with your actual selectors

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                const src = img.getAttribute('data-imgsrc');
                if (src) {
                    img.src = src;
                }
                observer.unobserve(img); // Optional: stop observing after load
            }
        });
    }, { rootMargin: '0px 0px 200px 0px' }); // Adjust rootMargin as needed

    images.forEach(img => observer.observe(img));
}